import React, { useContext } from 'react';

/**
 * This context is designed to separate the SYSTEM specific information, which is different
 *  between, for example, Passport ad EHCP - it contains things like layout sna styling
 *  which is static inb the user session context, but varies between systems
 *
 * @readonly
 * @enum {cosaNavButtonOperation}
 */
const SystemContext = React.createContext(null);
export default SystemContext;
export const useSystemContext = () =>  useContext(SystemContext) ;